import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

export function useFormatTime() {
    const t = useTranslations('common')
    const formatTime = useCallback(
        (totalDuration: number) => {
            const totalMinutes = Math.floor(totalDuration / 60)
            const hh = Math.floor(totalMinutes / 60)
            const mm = totalMinutes % 60
            const duration = t('duration', { hours: hh, minutes: mm })
            return duration
        },
        [t]
    )
    return formatTime
}
